var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhonepe({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 50C38.8071 50 50 38.8071 50 25C50 11.1929 38.8071 0 25 0C11.1929 0 0 11.1929 0 25C0 38.8071 11.1929 50 25 50Z",
    fill: "#5F259F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3513 18.4835C36.3513 17.4998 35.5317 16.6802 34.5481 16.6802H31.1874L23.4825 7.8687C22.7858 7.04903 21.6792 6.76214 20.5317 7.04903L17.8677 7.8687C17.4579 7.99165 17.294 8.56542 17.5808 8.85231L26.0235 16.8031H13.3185C12.9087 16.8031 12.6218 17.09 12.6218 17.4998V18.8933C12.6218 19.8769 13.4415 20.6966 14.4251 20.6966H16.3923V27.4179C16.3923 32.4589 19.0563 35.3687 23.5235 35.3687C24.9169 35.3687 26.0235 35.2458 27.4169 34.672V39.1392C27.4169 40.4097 28.4005 41.3933 29.671 41.3933H31.6382C32.0481 41.3933 32.4579 40.9835 32.4579 40.5736V20.5736H35.6546C36.0645 20.5736 36.3513 20.2867 36.3513 19.8769V18.4835ZM27.4169 30.4917C26.5972 30.9015 25.4497 31.0654 24.63 31.0654C22.3759 31.0654 21.2694 29.9589 21.2694 27.4179V20.6966H27.4169V30.4917Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhonepe);
export default __webpack_public_path__ + "static/media/phonepe.64f2f00e48a7213375b6ef92d474340e.svg";
export { ForwardRef as ReactComponent };